import { gql } from 'apollo-angular';

export const GET_MY_ROLE_OPEN_TASKS = gql`
  query GetMyRoleOpenTasks {
    myRoleOpenTasks {
      id
      businessKey
      businessType
      stageCode
      stageName
      status
      comment
      createdAt
      assigneeUserId
      actionTaken
      completedAt
      instanceId
      taskData
    }
  }
`;

export const LIST_NOTIFICATION_TEMPLATES_QUERY = gql`
  query ListNotificationTemplates($pageableParam: PageableParamInput) {
    listNotificationTemplates(pageableParam: $pageableParam) {
      content {
        uuid
        id
        name
        displayName
        content
        params
        type
        active
        isDocument
        documentPath
        createdAt
        updatedAt
      }
      totalElements
      number           # current page index (backend)
      size             # page size (backend)
      totalPages
      numberOfElements
      hasNext
      hasPrevious
    }
  }
`;

export const NOTIFICATION_TEMPLATE_BY_ID_QUERY = gql`
  query NotificationTemplateById($id: ID!) {
    notificationTemplateById(id: $id) {
      id
      availableVariable
      content
      contentExample
      contentType
      isActive
      name
      notificationChannel
      func
      result
    }
  }
`;

export const NOTIFICATION_TEMPLATE_BY_UUID_QUERY = gql`
  query NotificationTemplateByUuid($uuid: UUID!) {
    notificationTemplateByUuid(uuid: $uuid) {
      status
      code
      message
      data {
        uuid
        id
        name
        displayName
        content
        params
        type
        active
        isDocument
        documentPath
        createdAt
        updatedAt
      }
    }
  }
`;

export const UPDATE_NOTIFICATION_TEMPLATE_MUTATION = gql`
  mutation UpdateNotificationTemplate(
    $input: UpdateNotificationTemplateInputInput!
  ) {
    updateNotificationTemplate(input: $input) {
      status
      code
      message
      data {
        uuid
        id
        name
        displayName
        content
        params
        type
        active
        isDocument
        documentPath
        createdAt
        updatedAt
      }
    }
  }
`;

export const PREVIEW_NOTIFICATION_TEMPLATE_DOCUMENT_QUERY = gql`
  query PreviewNotificationTemplateDocument($uuid: UUID!) {
    previewNotificationTemplateDocument(uuid: $uuid) {
      status
      code
      message
      data
    }
  }
`;
export const DOWNLOAD_NOTIFICATION_TEMPLATE_DOCUMENT_QUERY = gql`
  query DownloadNotificationTemplateDocument($uuid: UUID!) {
    downloadNotificationTemplateDocument(uuid: $uuid) {
      status
      code
      message
      data
    }
  }
`;

export const DELETE_NOTIFICATION_TEMPLATE_MUTATION = gql`
  mutation DeleteNotificationTemplate($id: ID!) {
    deleteNotificationTemplate(id: $id)
  }
`;

export const TOGGLE_NOTIFICATION_TEMPLATE_STATUS_MUTATION = gql`
  mutation ToggleNotificationTemplateStatus($id: ID!) {
    toggleNotificationTemplateStatus(id: $id) {
      id
      isActive
    }
  }
`;
